export enum FrontPartnersIds {
  PARTNER_ID_BEPLIC = 1,
  PARTNER_ID_DOPPLER = 2,
}
